import NAME from "./constants";

export const getPolls = store => store[NAME].polls;
export const getQuestions = store => store[NAME].questions;
export const getAnswers = store => store[NAME].answers;
export const getIsLoading = store => store[NAME].isLoading;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;